import * as actionTypes from './type';
import { requestShowLoader, requestHideLoader } from '../Global/action';
import { handleCheckPermission } from '../../Utility/rolepermissionHelper';
import {  defaultmenuLabel } from '../../Utility/constant';
import history from '../../Utility/history';
import { publicRoutesPath } from '../../Routes';
import { getRequestData, searchRequestData } from '../../Utility/apiHelper';
import axiosInstance from '../../api/axiosInstance';
import { applyTheme, cacheTheme, getThemeFromResponse } from '../../Utility/theme';

export const requestgetAllUser = (currentCompanyId) => async(dispatch) => {
    dispatch(requestShowLoader())
    try {
        dispatch(requestShowLoader());
        // const responseData = await axios.get(`${process.env.REACT_APP_BASE_URL}users`, headerReq());
        const responseData = await getRequestData(`users/clientId/${currentCompanyId}`);
        dispatch({
            type: actionTypes?.RECEIVED_USER,
            payload: responseData?.data
        })
        
    } catch(error) {
        
    }
    dispatch(requestHideLoader())
}

export const requestgetcurrenctuser = (token) => async(dispatch) => {
    // Signal that the user fetch is in-flight so PublicRoute shows loader correctly
    dispatch({ type: actionTypes.REQUEST_CURRENT_USER });
    try {
        
        const responseData = await getRequestData(`logged-in`);
        await applyTheme(getThemeFromResponse(responseData));
        cacheTheme(getThemeFromResponse(responseData));
        var specificRoleuserdetails = null;

        var organizationLabel= null;

        const currentUser = responseData?.data;
        currentUser.is_firstuser = true;
        if(currentUser) {
           
            specificRoleuserdetails = await handleCheckPermission(currentUser?.authorities);
            if (currentUser?.resetPassword !== true) {
                dispatch(requestgetAllUser(currentUser?.client?.id));
            }
            organizationLabel = defaultmenuLabel;

            if(currentUser?.resetPassword === true) {

                // Dispatch RECEIVED_CURRENT_USER before navigating so isFetchingUser resets to false.
                // Without this, the BiztantuLoader introduced in PublicRoute would stay visible forever
                // on the set-user-password page because nothing resets isFetchingUser back to false.
                dispatch({
                    type: actionTypes?.RECEIVED_CURRENT_USER,
                    payload: {logeddata: responseData?.data, rolebasedData: specificRoleuserdetails, organizationLabel: organizationLabel}
                })

                history.push({
                    pathname: `${publicRoutesPath?.FIRST_USER_PASSWORD_SETUP}`,
                    state: {
                        token: token,
                        currentUserData: responseData?.data
                    }
                })

            } else {

           
                dispatch({
                    type: actionTypes?.RECEIVED_CURRENT_USER,
                    payload: {logeddata: responseData?.data, rolebasedData: specificRoleuserdetails, organizationLabel: organizationLabel}
                })

       
               

            }

            return currentUser?.client?.id
    
        } else {
            return currentUser?.client?.id
        }

       
    } catch(error) {
    }
}


export const handleUpdatePermissionSet = () => (dispatch) => {

    dispatch({
        type: actionTypes.UPDATE_CURRENT_USER_PERMISSION
    })

    dispatch({
        type: actionTypes?.CLER_TEAM_EMPTY
    })
}   



export const requestGetUserList=(queryparams) => async (dispatch)=>{
    try{

        dispatch({
        type: actionTypes.REQUEST_GET_USER
    })
    
    const clientSearchUrl = `${process.env.REACT_APP_BASE_URL}users`;
    
    const responsedata = await searchRequestData(queryparams , clientSearchUrl , false)
    dispatch({
        type: actionTypes.RECEIVED_SEARCHED_USER,
        payload : responsedata?.data
    })
    }
    catch(error){

    }


}


export const requestGetMyTeam =(id, updateStore = true) => async(dispatch)=>{
    try{
dispatch({
        type: actionTypes.REQUEST_GET_MY_TEAM
    })
    const clientSearchUrl = `${process.env.REACT_APP_BASE_URL}users/${id}/team`;
    const response = await getRequestData(clientSearchUrl)
    if(response?.status === 200){
    if(updateStore) {
        dispatch({
        type: actionTypes.RECEIVED_MY_TEAM,
        payload : response?.data
    })
    }
    return response?.data;
}
}
catch(error){
}
}

/**
 * Logs the user out by:
 *  1. Immediately clearing the access token from localStorage.
 *  2. Immediately dispatching LOGOUT to reset Redux state.
 *     (Steps 1 & 2 happen synchronously so the app stops treating
 *      the user as authenticated before any navigation occurs.)
 *  3. Calling POST /auth/logout as a fire-and-forget — revokes the refresh
 *     session in the DB and clears the biztantu_refresh HttpOnly cookie.
 *     Failures are silently ignored since local state is already cleared.
 */
export const requestLogout = () => async (dispatch) => {
    // Clear local state FIRST — this ensures that by the time the caller does
    // history.push('/'), Redux is already reset and no authenticated API calls
    // will fire from re-mounted components.
    localStorage.removeItem('accessToken');
    dispatch({ type: actionTypes.LOGOUT });

    // Fire-and-forget: revoke the server-side session in the background.
    try {
        await axiosInstance.post("auth/logout", {}, { withCredentials: true });
    } catch (_) {
        // Ignore errors — local state is already cleared above.
    }
}
